import { render, staticRenderFns } from "./AddDeviceNew.vue?vue&type=template&id=1758cde5&"
import script from "./AddDeviceNew.vue?vue&type=script&lang=js&"
export * from "./AddDeviceNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1758cde5')) {
      api.createRecord('1758cde5', component.options)
    } else {
      api.reload('1758cde5', component.options)
    }
    module.hot.accept("./AddDeviceNew.vue?vue&type=template&id=1758cde5&", function () {
      api.rerender('1758cde5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/adddevice/adddevicenew/AddDeviceNew.vue"
export default component.exports